import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../../utility/customAxios';
import { queryClient } from '../../queryClient';
import { queryKeys } from '../../queryKeys';

export const postRefreshOutlookAuth = async () => {
  const response = await CustomAxios.post(`integrations/outlook/refresh`);
  const { data } = response;
  return data;
};

interface ErrorResponse {
  error: string;
  message?: string;
}

export function useRefreshOutlookAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: postRefreshOutlookAuth,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.organizationIntegrations],
      });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data = err?.response?.data as ErrorResponse;
        if (data.error === 'OUTLOOK_AUTH_TOKEN_EXPIRED' || data.error === 'OUTLOOK_AUTH_MISSING') {
          navigate('/oauth2redirect-outlook');
        }
      }
    },
  });
}
